import { render, staticRenderFns } from "./appLookPPT.vue?vue&type=template&id=73fd3144&scoped=true&"
import script from "./appLookPPT.vue?vue&type=script&lang=js&"
export * from "./appLookPPT.vue?vue&type=script&lang=js&"
import style0 from "./appLookPPT.vue?vue&type=style&index=0&id=73fd3144&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fd3144",
  null
  
)

export default component.exports